<template>
<div class="work" id="work-8">
	<h2><span>06</span> Open Presentes</h2>
	<div class="subtitle">
		<h3><span>Year</span>2024</h3>
		<h3><span>Product</span>E-commerce</h3>
		<h3><span>Technology</span>Wordpress / Woocommerce</h3>
	</div>
	<blockquote>
		Open Presentes is a retailer of chinese products in the brazilian market, importing with special prices and vast amount of items.
	</blockquote>
	<figure class="half">
		<figcaption>
			<h3>Objective for this project</h3>
			<p>Develop the e-commerce of the company, multiplying their selling channels, encouraging the clients to have a straight relation with the store.</p>
			<h3>My Role</h3>
			<p>Design and develop the e-commerce with Wordpress and Woocommerce, providing a experience accordingly to the most known stores, pushing them the power to compete.</p>
		</figcaption>
		<img src="../../assets/op-01.png" alt="OPP home">
		<img src="../../assets/op-02.png" alt="Opp products">
	</figure>
	<figure class="half">
		<img src="../../assets/op-03.png" alt="OPP cart">
		<img src="../../assets/op-04.png" alt="Opp product">
		<figcaption>
			<h3>The Solution</h3>
			<p>The users are diverse in terms of social, economic, and purchasing styles. So, creating a store that suits all existing customers was a challenge.</p>
			<p>To select color scheme, elements, components, and content, we interviewed repeat customers and top partners to gather feedback and suggestions during development.</p>
		</figcaption>
	</figure>
	<figure>
		<figcaption>
			<blockquote>My part as designers and developer it's completed, unfortunatelly the administrators still waisting time to upload all the products and update prices, giving the customers a bad experience.
				And the visitors are huge number of people accessing the site, but the conversion is very low, because of that.
			</blockquote> 
		</figcaption>
	</figure>
	<figure>
		<span><img src="../../assets/op-Product.jpg" alt="Opp Vitrine"></span>
	</figure>
	<blockquote>
		"There's always a team effort in any project; we should stay synchronized. That said, I maintain my desire to see the store succeed. <a href="//openpresentes.com.br" target="_blank">openpresentes.com.br</a>"
	</blockquote>
</div>
</template>
<style scoped>
.half {
	margin-top: 120px;
}
.half img {
	border-radius: 80px;
}
</style>